import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

const LOADING_MESSAGES = [
    "Indizes werden geladen...",
    "Blöcke werden gesucht...",
    "Creeper werden gezählt...",
    "Diamanten werden geschürft...",
    "Endermen werden beobachtet...",
    "Chunks werden generiert...",
    "Redstone wird verkabelt...",
    "Villager handeln noch...",
    "Nether Portal wird aktiviert...",
    "Ender Dragon wird geweckt...",
    "Schweine werden gesattelt...",
    "Enchantments werden analysiert...",
    "Spawner werden lokalisiert...",
    "Stacktrace wird dekodiert...",
    "Java Heap wird durchsucht...",
    "Ghasts werden beruhigt...",
    "Wither wird beschworen...",
    "Obsidian wird abgebaut...",
    "Elytra werden gefaltet...",
    "Shulker werden sortiert...",
    "Tridents werden poliert...",
    "Beacon wird aktiviert...",
    "Piglins werden bestochen...",
    "Iron Golem wird gebaut...",
    "TNT wird entschärft...",
    "Skeleton Pferde werden gezähmt...",
    "Mooshrooms werden gemolken...",
    "Axolotl werden gesammelt...",
    "Warden lauscht noch...",
    "Allays tanzen noch...",
];

const getRandomMessage = () => LOADING_MESSAGES[Math.floor(Math.random() * LOADING_MESSAGES.length)]!;

interface FunLoaderProps {
    showProgress?: boolean;
    progress?: number;
    messageInterval?: number;
    size?: 'sm' | 'md' | 'lg';
}

export const FunLoader: React.FC<FunLoaderProps> = ({
    showProgress = false,
    progress = 0,
    messageInterval = 1500,
    size = 'md'
}) => {
    const [message, setMessage] = useState(getRandomMessage);

    useEffect(() => {
        const interval = setInterval(() => {
            setMessage(getRandomMessage());
        }, messageInterval);
        return () => clearInterval(interval);
    }, [messageInterval]);

    const sizeMap = {
        sm: 32,
        md: 48,
        lg: 64
    };

    return (
        <div className="flex flex-col items-center justify-center h-full space-y-6 p-8">
            <div className="relative">
                <Loader2 size={sizeMap[size]} className="text-blue-500 animate-spin" />
                {showProgress && (
                    <div className="absolute inset-0 flex items-center justify-center">
                        <span className="text-xs font-bold text-blue-400">{progress}%</span>
                    </div>
                )}
            </div>
            
            {showProgress && (
                <div className="w-64">
                    <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                        <div 
                            className="h-full bg-gradient-to-r from-blue-500 to-ember rounded-full transition-all duration-300"
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                </div>
            )}
            
            <p className="text-fg-muted text-sm animate-pulse text-center max-w-xs">
                {message}
            </p>
        </div>
    );
};
